import voyageApi from '@/api/vsl/voyage.api';

const initialState = () => ({
  voyageList: [],
});

const state = initialState();
const getters = {};
const mutations = {
  RESET(state, payload) {
    const initStates = initialState();
    if (!payload) {
      Object.keys(initStates).map((key) => {
        state[key] = initStates[key];
      });
    } else {
      const statesToReset = payload;
      statesToReset.map((key) => {
        state[key] = initStates[key];
      });
    }
  },
  SET_VOYAGE_LIST(state, payload) {
    state.voyageList = payload;
  },
};
const actions = {
  async fetchVoyageList({ commit }, payload) {
    const res = await voyageApi.getVoyageList({});

    const mapped = res.data.data.map(({ code }) => ({
      code: code,
      name: code,
    }));
    commit('SET_VOYAGE_LIST', mapped);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
